module.exports = __webpack_public_path__ + "static/img/images3.003270c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/images/images3.jpg
// module id = 87az
// module chunks = 36